import React, { useContext } from "react";

import { ContextProvider } from "../../App";

import OrderCompletionFormModal from "./OrderCompletionFormModal.jsx";

function OrderDetails({ cartState, tomorrow, selectionPlan, title }) {
  const { modalsState, modalsDispatch } = useContext(ContextProvider);
  // console.log(cartState);

  const handleConfirm = () => {
    modalsDispatch({ type: "OPEN_ORDER_COMPLETION_MODAL" });
  };

  const closeOrderCompletionModal = () => {
    modalsDispatch({ type: "CLOSE_ORDER_COMPLETION_MODAL" });
  };

  return (
    <>
      <div className="order_details_box">
        <div className="order_details_content">
          <h3 style={{ textAlign: "center" }}>Order Details</h3>
          <hr
            className="order_details_line"
            style={{ marginBottom: "1.5rem" }}
          />
          {selectionPlan === "daily" ? (
            <div className="order_details_selected_items">
              <p>{tomorrow}</p>
              {cartState.selectedOrder.dailyTitle !== "" ? (
                <p>
                  { cartState.selectedOrder.dailyTitle } {cartState.menuObj.qty}X
                </p>
              ) : (
                <p>Not Selected</p>
              )}
            </div>
          ) : (
            <>
              <div className="order_details_selected_items">
                <p>Monday</p>
                {cartState.selectedOrder.monday !== "" ? (
                  <p>
                      { cartState.selectedOrder.monday.title} {cartState.selectedOrder.monday.qty}X
                  </p>
                ) : (
                  <p>Not Selected</p>
                )}
              </div>
              <div className="order_details_selected_items">
                <p>Tuesday</p>
                {cartState.selectedOrder.tuesday !== "" ? (
                  <p>
                      { cartState.selectedOrder.tuesday.title} {cartState.selectedOrder.tuesday.qty}X
                  </p>
                ) : (
                  <p>Not Selected</p>
                )}
              </div>
              <div className="order_details_selected_items">
                <p>Wednesday</p>
                {cartState.selectedOrder.wednesday !== "" ? (
                  <p>
                      { cartState.selectedOrder.wednesday.title} {cartState.selectedOrder.wednesday.qty}X
                  </p>
                ) : (
                  <p>Not Selected</p>
                )}
              </div>
              <div className="order_details_selected_items">
                <p>Thursday</p>
                {cartState.selectedOrder.thursday !== "" ? (
                  <p>
                      { cartState.selectedOrder.thursday.title} {cartState.selectedOrder.thursday.qty}X
                  </p>
                ) : (
                  <p>Not Selected</p>
                )}
              </div>
              <div className="order_details_selected_items">
                <p>Friday</p>
                {cartState.selectedOrder.friday !== "" ? (
                  <p>
                      { cartState.selectedOrder.friday.title} {cartState.selectedOrder.friday.qty}X
                  </p>
                ) : (
                  <p>Not Selected</p>
                )}
              </div>
            </>
          )}
          <hr className="order_details_line" style={{ marginTop: "1.3rem" }} />
          <div className="bottom_div_btn">
            {selectionPlan === "weekly" && (
              <h3>
                TOTAL <b style={{ marginLeft: "1rem" }}>-50 NOK</b>
              </h3>
            )}
            {selectionPlan === "monthly" && (
              <h3>
                TOTAL <b style={{ marginLeft: "1rem" }}>-200 NOK</b>
              </h3>
            )}
            {selectionPlan === "daily" && (
              <h3>
                TOTAL <b style={{ marginLeft: "1rem" }}>-10 NOK</b>
              </h3>
            )}

            <button
              type="button"
              className="btn_confirm_order"
              onClick={handleConfirm}
            >
              CONFIRM
            </button>
          </div>
        </div>
      </div>
      {/* Order completion form modal */}
      <OrderCompletionFormModal
        orderFormModal={modalsState.orderCompletionModal}
        closeOrderCompletionModal={closeOrderCompletionModal}
      />
    </>
  );
}

export default OrderDetails;
